// "Powered by FlowCare" with the small wordmark (brief 1E-35b, mockup v94, docs/design/brand/).
// The one-colour ink wordmark on light screens and the white one in dark mode (app/styles.css).

import { el } from "./dom";

/** The quiet FlowCare line at the foot of the rail, the menu sheet, the field app and sign-in. */
export function poweredBy(tag: "div" | "p" = "div"): HTMLElement {
  return el(
    tag,
    { class: "poweredby small muted" },
    "Powered by ",
    el("img", { class: "wm wm-ink", src: "/flowcare-wordmark-mono-ink.svg", alt: "FlowCare" }),
    el("img", { class: "wm wm-white", src: "/flowcare-wordmark-mono-white.svg", alt: "FlowCare" }),
  );
}
